'use client';

import { useEffect, useState } from 'react';

import Nav from '@/components/features/common/nav';
import ErrorComponent, { ErrorProps } from '@/components/ui/error';
import { useLanguage } from '@/hooks/use-language';
import { getLanguage } from '@/utils/dictionary';
import { isEmpty } from '@/utils/object';

export default function Error(props: ErrorProps) {
  const { currentLanguage } = useLanguage();
  const [dictionary, setDictionary] = useState<Record<string, string>>({});

  useEffect(() => {
    getLanguage(Promise.resolve({ lang: currentLanguage }), 'common').then(
      setDictionary,
    );
  }, []);

  if (isEmpty(dictionary)) {
    return null;
  }

  return (
    <div className="flex h-screen flex-col">
      <div>
        {/* 导航 */}
        <Nav dictionary={dictionary} isErrorPage />
      </div>
      <main className="fle-1 overflow-y-auto">
        <ErrorComponent {...props} className="mt-[213px]" />
      </main>
    </div>
  );
}
